export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9761.00545467.jpg";